import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { categoryService } from "../services/category.service";

// Type definitions
export interface CategoryData {
    id: number;
    name: string;
    description: string;
    icon: string;
}

export interface CategoryState {
    categories: CategoryData[];
    loading: boolean;
    error: string | null;
}

const initialState: CategoryState = {
    categories: [],
    loading: false,
    error: null,
};

// Async thunks
export const fetchAllCategories = createAsyncThunk<CategoryData[], void, { rejectValue: string }>("category/fetchAll", async (_, { rejectWithValue }) => {
    try {
        return await categoryService.getAll();
    } catch (error: any) {
        return rejectWithValue(error.message || "Failed to fetch categories");
    }
});

const categorySlice = createSlice({
    name: "category",
    initialState,
    reducers: {
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchAllCategories.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchAllCategories.fulfilled, (state, action) => {
                state.loading = false;
                state.categories = action.payload;
                state.error = null;
            })
            .addCase(fetchAllCategories.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            });
    },
});

export default categorySlice.reducer;

